import { Clipboard } from "@capacitor/clipboard";
import { Capacitor } from "@capacitor/core";

export const copyToClipboard = async (stringToCopy: string): Promise<boolean> => {
  try {
    // Native platform
    if (Capacitor.isNativePlatform()) {
      await Clipboard.write({ string: stringToCopy });
      return true;
    }

    // Web platform
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(stringToCopy);
      return true;
    }

    // Legacy browser
    if (document.queryCommandEnabled("copy")) {
      document.execCommand("copy");
      return true;
    }
  } catch (err: any) {
    console.error("Failed to copy to clipboard: ", err?.message);
    return false;
  }

  return false;
};